import groq from "groq";
export const imageObject = groq`

  imageObject {
           ...,
         image {
          ...,
           asset->{
            ...,
            _id,
            url,
            _type,
            altText,
            description,
            title,
              metadata {
                blurHash,
                dimensions,
              }
            }
          },    
        }
`;
